export class Observable {
  constructor() {
    this.subscribers = [];
    this.subscribe = cb => {
      this.subscribers.push(cb);
      return () => {
        this.subscribers = this.subscribers.filter(sub => sub !== cb);
      };
    };
    this.notifySubscribers = () => {
      for (const subscriber of this.subscribers) {
        subscriber(this.state);
      }
    };
    this.setState = partialNewState => {
      const newState = Object.assign({}, this.state, partialNewState);
      this.state = newState;
      this.notifySubscribers();
    };
    this.getState = () => {
      return this.state;
    };
  }
}